import Link from "next/link";
import { linkStyle } from "@/styles/sharedStyle";
import { useRouter } from "next/router";
import { getUrlWithQuery } from "@/libs/url";
import config from "@/libs/config";

type Props = {};

export const SignInLink = (props: Props) => {
  const router = useRouter();
  const { app } = router.query;

  return (
    <Link href={getUrlWithQuery("/sign-in", app)}>
      <a css={linkStyle}>
        {config.BANK_NICKNAME} Mikatano シリーズへログインするにはこちらへ
      </a>
    </Link>
  );
};
